import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SLIDESHOWIMAGEBLOCK_LEGACY_FIELD_ORDER = [
  "anchor",
  "title"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  slideShowImageBlockDescriptor: _generatedSlideShowImageBlockDescriptor,
  slideShowImageBlockBlocDefinition,
  slideShowImageBlockDashboardLayout,
  slideShowImageBlockConfig,
  slideShowImageBlockResolveConfig,
  slideShowImageBlockProperties,
} = doodBlockConfig(
  {
    name: "Slideshow Images",
    componentType: 'SlideShowImageBlockComponent',
    category: 'media',
    description: "Slideshow Images.",
    keywords: [],
    sharedFields: {}
,
    slots: [
      {
        key: 'images',
        name: "pages.blocks.slide-show-image.images.label",
        accept: 'explicitOnly',
        allowedTypes: ["ImageOfSlideShowBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    anchor: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.slide-show-image.anchor.label",
        help: "pages.blocks.slide-show-image.anchor.help",
      }
    }),
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.slide-show-image.title.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.slide-show-image.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.slide-show-image.fieldset.section.label",
            fields: ["title", "anchor"],
          },
          {
            legend: "pages.blocks.slide-show-image.fieldset.images.label",
            fields: ["images"],
          },
        ],
      },
    ],
  })
);

export function slideShowImageBlockDescriptor(): IBlockDescriptor;
export function slideShowImageBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function slideShowImageBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedSlideShowImageBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedSlideShowImageBlockDescriptor, slideShowImageBlockProperties, fieldOrder);
}

export {
  slideShowImageBlockBlocDefinition,
  slideShowImageBlockDashboardLayout,
  slideShowImageBlockProperties,
  slideShowImageBlockConfig,
  slideShowImageBlockResolveConfig,
};

export type SlideShowImageBlockConfig = typeof slideShowImageBlockConfig;
